import {
  STARK_LOGS_LIST,
  STARK_LOG_GET,
  STARK_LOG_CREATE,
  STARK_LOG_UPDATE,
  STARK_LOG_DELETE,
  STARK_LOGS_BY_NOTE,
  STARK_PROVIDER_TOTALS,
  STARK_INVALIDATE,
} from 'store/actions/starkActions';

const initialState = {
  logs:           { data: [], loading: false, error: null },
  log:            { data: null, loading: false, error: null },
  notelogs:       { data: [], loading: false, error: null },
  providerTotals: { data: [], loading: false, error: null },
  invalidatedAt:  null,
};

const getData = (action) => action.response?.data ?? action.data ?? null;

export const stark = (state = initialState, action = null) => {
  if (!action) return state;

  switch (action.type) {

    // ── Provider totals ────────────────────────────────────────────────────
    case STARK_PROVIDER_TOTALS:
      return { ...state, providerTotals: { ...state.providerTotals, loading: true, error: null } };
    case `${STARK_PROVIDER_TOTALS}_SUCCESS`:
      return { ...state, providerTotals: { data: getData(action) || [], loading: false, error: null } };
    case `${STARK_PROVIDER_TOTALS}_ERROR`:
      return { ...state, providerTotals: { data: [], loading: false, error: action.error } };

    // ── List logs ──────────────────────────────────────────────────────────
    case STARK_LOGS_LIST:
      return { ...state, logs: { ...state.logs, loading: true, error: null } };
    case `${STARK_LOGS_LIST}_SUCCESS`:
      return { ...state, logs: { data: getData(action) || [], loading: false, error: null } };
    case `${STARK_LOGS_LIST}_ERROR`:
      return { ...state, logs: { data: [], loading: false, error: action.error } };

    // ── Logs by note ───────────────────────────────────────────────────────
    case STARK_LOGS_BY_NOTE:
      return { ...state, notelogs: { data: [], loading: true, error: null } };
    case `${STARK_LOGS_BY_NOTE}_SUCCESS`:
      return { ...state, notelogs: { data: getData(action) || [], loading: false, error: null } };
    case `${STARK_LOGS_BY_NOTE}_ERROR`:
      return { ...state, notelogs: { data: [], loading: false, error: action.error } };

    // ── Get single log ─────────────────────────────────────────────────────
    case STARK_LOG_GET:
      return { ...state, log: { data: null, loading: true, error: null } };
    case `${STARK_LOG_GET}_SUCCESS`:
      return { ...state, log: { data: getData(action), loading: false, error: null } };
    case `${STARK_LOG_GET}_ERROR`:
      return { ...state, log: { data: null, loading: false, error: action.error } };

    // ── Create log ─────────────────────────────────────────────────────────
    case STARK_LOG_CREATE:
      return { ...state, log: { data: null, loading: true, error: null } };
    case `${STARK_LOG_CREATE}_SUCCESS`: {
      const created = getData(action);
      const newLog  = created?.log || created; // createLog returns { log, warnings }
      return {
        ...state,
        log:  { data: newLog, loading: false, error: null },
        logs: {
          ...state.logs,
          data: [newLog, ...(state.logs.data || [])],
        },
      };
    }
    case `${STARK_LOG_CREATE}_ERROR`:
      return { ...state, log: { data: null, loading: false, error: action.error } };

    // ── Update log ─────────────────────────────────────────────────────────
    case STARK_LOG_UPDATE:
      return { ...state, log: { ...state.log, loading: true, error: null } };
    case `${STARK_LOG_UPDATE}_SUCCESS`: {
      const result  = getData(action);
      const updated = result?.log || result;
      return {
        ...state,
        log:  { data: updated, loading: false, error: null },
        logs: {
          ...state.logs,
          data: (state.logs.data || []).map((l) =>
            l.id === updated?.id ? updated : l
          ),
        },
      };
    }
    case `${STARK_LOG_UPDATE}_ERROR`:
      return { ...state, log: { ...state.log, loading: false, error: action.error } };

    // ── Delete log ─────────────────────────────────────────────────────────
    case `${STARK_LOG_DELETE}_SUCCESS`: {
      const deletedId = action.meta?.requestAction?.id;
      return {
        ...state,
        logs: {
          ...state.logs,
          data: (state.logs.data || []).filter((l) => l.id !== deletedId),
        },
      };
    }

    // ── Invalidate cache ───────────────────────────────────────────────────
    case STARK_INVALIDATE:
      return { ...state, invalidatedAt: Date.now() };

    default:
      return state;
  }
};
